import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderBumpComponent } from './order-bump.component';
import { PlaceholderComponent } from './placeholder/placeholder.component';
import { createCustomElement } from '@angular/elements';
import { ProductPriceModule } from '../product-price/product-price.module';
import { QuantityInputModule } from '../product-list/quantity-input/quantity-input.module';
import { ReactiveFormsModule } from '@angular/forms';
import { QuantityDiscountModule } from '../product-list/quantity-discount/quantity-discount.module';

@NgModule({
  declarations: [OrderBumpComponent, PlaceholderComponent],
  imports: [
    ProductPriceModule,
    QuantityInputModule,
    QuantityDiscountModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  exports: [OrderBumpComponent, PlaceholderComponent],
})
export class OrderBumpModule {
  static initialize(injector) {
    const customComponent = createCustomElement(OrderBumpComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-order-bump', customComponent);

    const orderBumpPlaceholderComponent = createCustomElement(
      PlaceholderComponent,
      {
        injector: injector,
      }
    );
    customElements.define(
      'ds-orderform-order-bump-placeholder',
      orderBumpPlaceholderComponent
    );
  }
}
